import BBPlugin from './plugin';
import { IBrowserInfo, ICommandArgs, ICommandResponse } from "./types";

export class Browser
{
    public static STATE_NFC_OFF = 1;
    public static STATE_NFC_TURNING_ON = 2;
    public static STATE_NFC_ON = 3;
    public static STATE_NFC_TURNING_OFF = 4;
    public static BUTTON_FN1 = 21;
    public static BUTTON_FN2 = 22;
    public static BUTTON_FN3 = 23;

    private generalPlugin: BBPlugin;
    public plugins: {[key: string]: BBPlugin};
    public info: IBrowserInfo;
    public client;

    constructor(clientAPI?: string)
    {
        let info: ICommandResponse = null;
        this.plugins = {};
        this.info = {versionName: 'N/A', versionNumber: -1 , plugins: {}}; 
        this.client = window.hasOwnProperty('__bb__') ? window.__bb__ : null;
        info = this.cmd('activate', {
            clientAPI: clientAPI || 'BluugoBrowser'
        });

        if (info.success) 
        {
            this.info = info.results;
            window.addEventListener('unload', () =>
            {
                this.cmd('reset');
            });
        }
    }

    protected _trigger(specs): void
    {
        let event = specs.event,
            args = specs.args,
            name = null;
        if (specs.cids) 
        {
            specs.cids.forEach(function (cid) 
            {
                if (this.plugins.hasOwnProperty(cid)) 
                {
                    this.plugins[cid].trigger(event, args);
                }
            }, this);
        } else 
        {
            for (name in this.plugins) 
            {
                if (this.plugins.hasOwnProperty(name)) 
                {
                    this.plugins[name].trigger(event, args);
                }
            }
        }
    }

    public isAvailable(): boolean
    {
        return this.client ? true : false;
    }

    public cmd(name: string, args?: ICommandArgs): ICommandResponse
    {
        if (this.client) 
        {
            let strResult = '';
            if (this.client) 
            {
                strResult = this.client.cmd(JSON.stringify({
                    cmd: name,
                    args: args || null
                }));
            }
            return JSON.parse(strResult) || null;
        } 
        else 
        {
            return { success: false, error: 'BB not available' };
        }
    }

    public hasPlugin(name: string): boolean
    {
        return this.info.plugins.hasOwnProperty(name);
    }

    public plugin(name: string): BBPlugin
    {
        let info = this.cmd('plugin', {name: name}),
            plugin = null;
        if (info.success) 
        {
            plugin = new BBPlugin(
                this,
                info.results.cid,
                info.results.name,
                info.results.info
            );
            this.plugins[plugin.cid] = plugin;
            return plugin;
        }
        return new BBPlugin(this, null, name);
    }

    public getGeneralPlugin()
    {
        if (!this.generalPlugin) {
            this.generalPlugin = this.plugin('general');
        }
        return this.generalPlugin;
    }

    public reload(clearCache: boolean)
    {
        this.getGeneralPlugin().call('reload', { clearCache });
    }
}

export default new Browser('Bluugo.Browser');